import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function EquipmentBox(props) {
  const {
    currentVariant,
    isDealerConfigurator,
    strings
  } = useContext(ConfiguratorContext)
  const selectedEquipmentString = strings.selected_equipment ?? {}

  if (isDealerConfigurator || currentVariant.equipments.length === 0) {
    return null
  }

  return (
    <div className='config-text'>
      <h2 className='config-text__title'>{selectedEquipmentString.title}</h2>
      <div className='config-text__text'>
        <ul>
          {currentVariant.equipments.map((equipment, i) => <li key={i}>{equipment}</li>)}
        </ul>
      </div>
      {
        typeof selectedEquipmentString.link_title !== 'string' || selectedEquipmentString.link_title.length < 1 ||
        typeof currentVariant.equipment_url !== 'string' || currentVariant.equipment_url.length < 1
          ? null
          : (<div className='config-text__buttons'>
            <a
              href={currentVariant.equipment_url}
              target="_blank"
              className='inline-button'
            >
              {selectedEquipmentString.link_title}
            </a>
          </div>)
      }
    </div>
  )
}
